module.exports = __webpack_public_path__ + "img/popup-warning.07799d55.png";